import Debug from './_debug';
import $ from 'jquery';

let Filters = {};  
Filters.themeUrl = $('.site-logo').parent().attr('href'); ; 
Filters.isMobileSidebarActive = false;

Filters.initialize = () => {
  Debug.log('Filters: initialize');

  if ($('.sidebar-filters').length > 0) {
    $('.mobile-close').on('click', function() {
      Filters.toggleMobileSidebar();
      Filters.isMobileSidebarActive = false;
    });
    $('.mobile-open').on('click', function() {
      Filters.toggleMobileSidebar();
      Filters.isMobileSidebarActive = true;
    });
  } 

  if ($('.publications-template') && $('.publications-template').length > 0) {
    Filters.initializePublicationsFilters();
  }   
  if ($('.etp-template') && $('.etp-template').length > 0) {
    Filters.initializeEtpFilters();
  }   
}

Filters.toggleMobileSidebar = function() {
  console.log($('.sidebar'));
  $('.sidebar').toggleClass('d-none');
}; 

//Filters
Filters.initializePublicationsFilters = () => {
  let filter = $('#publications-form');
  $('.publications-template .sidebar-filters button').on('click', function(event) {
    event.preventDefault();
    Filters.ajaxPost(filter);
    return false;
  });
  $('#filter-publications-maladies').on('change', function(){
    Filters.ajaxPost(filter);
    return false;
  });
  Filters.initializeAjaxPagination(filter);
}

Filters.initializeEtpFilters = () => {
  console.log('initializeEtpFilters');
  let filter = $('#etp-form');
  $('.etp-template .sidebar-filters button').on('click', function(event) {
    event.preventDefault();
    Filters.ajaxPost(filter);
    return false;
  });
  $('#filter-etp-maladies').on('change', function(){
    Filters.ajaxPost(filter);
    return false;
  });
  $('[name="filter-etp-public[]"]').on('change', function(){
    Filters.ajaxPost(filter);
    return false;
  });
  $('[name="filter-etp-type-de-centre[]"]').on('change', function(){
    Filters.ajaxPost(filter);
    return false;
  });
  Filters.initializeAjaxPagination(filter);
}


//Generic functions
Filters.initializeAjaxPagination = (filter) => {
  $(document).on( 'click', '.nav-links a', function( event ) {
    event.preventDefault();

    let page = $(this)[0].innerText;

    if ($(this).hasClass('next')) {
        page = parseInt ($('.nav-links .current')[0].innerText) + 1
    }
    if ($(this).hasClass('previous')) {
        page = parseInt ($('.nav-links .current')[0].innerText) - 1
    }

    Filters.ajaxPost(filter, ('&page=' + page));
  });
}

Filters.ajaxPost = (filter, extraDataString) => {
  let filterObject = filter;
  let formData = filterObject.serializeArray();
  var groupedData = {};

  formData.forEach(input => {
    var name = input.name;
    var value = input.value;

    if ($('[name="' + name + '"]').is('select[multiple]') || 
       ($('[name="' + name + '"]').is('input') && name.indexOf('[]') > 0)) {
      if (!groupedData[name]) {
        groupedData[name] = [];
      }
      groupedData[name].push(value);
    } else {
      groupedData[name] = value;
    }
  });

  console.log('groupedData', groupedData);

  let formDataMultiple = '';

  let index = 0;
  for (const [key, value] of Object.entries(groupedData)) {
    if (index > 0) { formDataMultiple += '&'; }
    formDataMultiple += `${key}=${value}`;
    index++;
  }

  if (typeof extraDataString !== 'undefined') {
    formDataMultiple += extraDataString;
  }
  $.ajax({
      url:filterObject.attr('action'),
      data:formDataMultiple,
      type:filterObject.attr('method'),
      beforeSend:function(xhr){
        filterObject.find('.loader').addClass('d-inline-block').removeClass('d-none');
      },
      success:function(data){
        filterObject.find('.loader').addClass('d-none').removeClass('d-inline-block');
        $('#list-results').html(data);
        if (Filters.isMobileSidebarActive) {
          Filters.toggleMobileSidebar();
          Filters.isMobileSidebarActive = false;
        }
        Filters.customizeTags();
      }
  });
}

Filters.customizeTags = () => {
  $('.tag').not('.secondary').append('<img class="tag-custom-bg" src="' + Filters.themeUrl + '/wp-content/themes/respifil/dist/images/tag-bg.png" />');
  $('.tag.secondary').append('<img class="tag-custom-bg" src="' + Filters.themeUrl + '/wp-content/themes/respifil/dist/images/tag-bg-secondary.png" />');
}


export default Filters;